import { MATCH_DEFAULT, MATCH_DURATION } from "@/constants";
import { MatchesAPI } from "@/services/api";
import { firestore } from "@/services/firebase";
import { uuidv4 } from "vue-chess-shared/utils";
import { serverTimestamp } from "./firebase-helper";

function getBufferDuration(duration) {
  if (duration >= MATCH_DURATION.RAPID) return 20;
  if (duration >= MATCH_DURATION.BLITZ) return 15;
  return 10;
}

const MatchHelper = {
  async createMatch({
    matchId,
    whitePlayer,
    blackPlayer,
    gameOverride,
    duration,
    increment,
    variant,
    initialFen,
    tournamentId,
    roundNumber,
    board,
    simulId,
  }) {
    if (!matchId) matchId = uuidv4();

    const aiLevel = whitePlayer.aiLevel || blackPlayer.aiLevel;

    // Create Match in SQLDB
    const sqlMatch = await MatchesAPI.postMatch({
      match_id: matchId,
      game_override: gameOverride ? gameOverride : MATCH_DEFAULT.GAME_OVERRIDE,
      player_1_id: whitePlayer.username,
      player_2_id: blackPlayer.username,
      duration: duration,
      increment,
      variant: variant ? variant : MATCH_DEFAULT.VARIANT,
      ai_rating: aiLevel ? aiLevel : null,
    });
    if (!sqlMatch) return null;

    // Create Match in Firebase
    try {
      await firestore
        .collection("matches")
        .doc(matchId)
        .set({
          match_id: matchId,
          duration: duration,
          increment: increment ? increment : 0,
          buffer_duration: getBufferDuration(duration),
          gameOverride: gameOverride
            ? gameOverride
            : MATCH_DEFAULT.GAME_OVERRIDE,
          variant: variant,
          player1: whitePlayer,
          player2: blackPlayer,
          playerIds: [whitePlayer.username, blackPlayer.username],
          status: "live",
          result: "",
          startedAt: serverTimestamp(),
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp(),
          initial_fen: initialFen ? initialFen : "",
          //below params are for tournament only
          tournamentId: tournamentId ? tournamentId : null,
          roundNumber: roundNumber ? roundNumber : null,
          board: board ? board : null,
          simulId: simulId ? simulId : null,
        });
    } catch (error) {
      console.error("Error writing document: ", error);
      return null;
    }

    console.log("Match created:", matchId);
    return matchId;
  },
};

export default MatchHelper;
